import { styled } from '@mui/material';
import { PageContext } from 'pages/ForgotPassword/PageProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Form, Link, Stack, Text, TextInput } from 'shell/components';

const ResetPasswordPage = ({ device, errors, form, handleChange, handleSendForgotPasswordCode }) => {
    const { t } = useTranslation('auth');
    const { loading } = useContext(PageContext);

    return (
        <EmailBox device={device}>
            <Stack alignItems={'center'} spacing={1} sx={{ marginBottom: 6 }}>
                <Text component={'h1'} variant={'h6'} weight={'medium'}>
                    {t('forgot-password.title', 'Forgot Password')}
                </Text>
                <Text variant={'p1'} align={'center'}>
                    {t(
                        'forgot-password.description',
                        'No need to worry! An email will be sent to you with instructions on how to reset your password.'
                    )}
                </Text>
            </Stack>
            <Form onSubmit={() => handleSendForgotPasswordCode()}>
                <InputStack spacing={6}>
                    <TextInput
                        data-cy={'forgot-password-email-input'}
                        error={Boolean(errors.email)}
                        helperText={errors.email}
                        label={t('form.email-label', 'Email')}
                        value={form.email}
                        onChange={(e) => handleChange('email', e.target.value)}
                        placeholder={t('form.email-placeholder', 'Enter email')}
                        required
                    />
                </InputStack>

                <Stack sx={{ margin: (theme) => theme.spacing(6, 0, 3, 0) }}>
                    <Button data-cy={'forgot-password-send-email-button'} loading={loading} type={'submit'}>
                        {t('forgot-password.send-email', 'Send Email')}
                    </Button>
                </Stack>
                <Stack alignItems={'center'}>
                    <Text>
                        <Link to={'/'}>{t('forgot-password.return-to-login', 'Return to login')}</Link>
                    </Text>
                </Stack>
            </Form>
        </EmailBox>
    );
};

const EmailBox = styled(Box)(({ theme, device }) => {
    return {
        marginTop: theme.spacing(12),
        padding: device === 'mobile' ? 0 : theme.spacing(7),
        width: device === 'mobile' ? '100%' : 448,
        height: 'fit-content',
        background: device === 'mobile' ? 'transparent' : theme.palette.ensightful.shades[0],
        boxShadow: device === 'mobile' ? 'none' : theme.palette.ensightful.shadows[1],
        borderRadius: '20px',
    };
});

const InputStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 2, 0),
    };
});

export default ResetPasswordPage;
